/**
 * Toggles visibility of an element by adding/removing the 'visible' class
 */
export function toggleVisibility(element: HTMLElement | null, show?: boolean): void {
  if (!element) return;

  if (show === undefined) {
    element.classList.toggle('visible');
  } else if (show) {
    element.classList.add('visible');
  } else {
    element.classList.remove('visible');
  }
}

/**
 * Gets an element by ID with type safety
 */
export function getElement<T extends HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/**
 * Escapes HTML special characters
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
